<!--
  --
  -- 乗り捨てサービス入力コンポーネント
  --
  -->
<template>
  <div>

    <!-- 利用する/しない -->
    <v-radio-group
      v-model="used"
      class="mt-0"
      dense hide-details
    >
      <v-radio label="利用しない" :value="false" />
      <v-radio label="利用する" :value="true" />
    </v-radio-group>

    <!-- 返却先 情報 -->
    <div class="mt-4">
      <div>
        <span class="mr-4">返却先</span>
        <span class="text-body-1 primary--text">{{to.name}}</span>
      </div>

      <div v-if="to.address" class="mt-1">{{to.address}}</div>

      <div v-if="to.charge" class="mt-1">{{to.charge | comma}} 円</div>

      <div class="mt-2">
        <v-dialog
          v-model="toDialog"
          width="304"
        >
          <template #activator="{on}">
            <v-btn text outlined :disabled="!used" v-on="on" v-text="to.buttonLabel" />
          </template>

          <c-returns-to-card
            v-model="stationID"
            :stations="returns.stations"
            @close="toDialog = false"
          />
        </v-dialog>
      </div>
    </div>

  </div>
</template>

<script>
import CReturnsToCard from './CReturnsToCard'

export default {
  name: 'CReturnsInput',
  components: {
    CReturnsToCard
  },

  props: {
    returns: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    // 乗り捨てサービスを利用するか
    used: false,

    // 選択したステーションID
    stationID: 0,

    toDialog: false
  }),

  computed: {
    /**
     * 返却先情報
     */
    to () {
      const station = this.returns.stations.find(item => item.stationID === this.stationID)

      if (!station) {
        return {
          name: '未選択',
          address: '',
          charge: 0,
          buttonLabel: '設定する'
        }
      }

      return {
        name: station.name,
        address: station.address,
        charge: station.charge,
        buttonLabel: '変更する'
      }
    }
  },

  /**
   * stationID が変更されたら、returns.stationID に反映する
   */
  watch: {
    used (value) {
      this.returns.stationID = value ? this.stationID : 0
    },

    stationID (value) {
      this.returns.stationID = value
    }
  },

  /**
   * returns プロパティの選択内容を used, stationID に反映する
   */
  created () {
    this.used = (this.returns.stationID !== 0)
    this.stationID = this.returns.stationID
  }
}
</script>
